class CodeltyProductPage {
  constructor() {
    this.initGallery();
  }

  initGallery() {
    const gallery = document.querySelector('.codelty-product-page media-gallery');
    if (!gallery) return;

    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const thumbRoot = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!viewer || !thumbRoot) return;

    const mqlDesktop = window.matchMedia('(min-width: 990px)');

    const scrollActiveThumb = () => {
      if (!mqlDesktop.matches) return;
      const active = thumbRoot.querySelector('.thumbnail[aria-current="true"]');
      if (!active) return;
      const item = active.closest('.thumbnail-list__item');
      const list = thumbRoot.querySelector('.thumbnail-list');
      if (!item || !list) return;
      const top = item.offsetTop - list.clientHeight / 2 + item.offsetHeight / 2;
      list.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    };

    viewer.addEventListener('slideChanged', () => window.requestAnimationFrame(scrollActiveThumb));
    thumbRoot.addEventListener('click', (event) => {
      if (event.target.closest('.thumbnail')) window.setTimeout(scrollActiveThumb, 80);
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new CodeltyProductPage());
} else {
  new CodeltyProductPage();
}
